import { planCanUse, type FeatureKey } from '@shared/config';

export interface EntitlementContext {
  plan: 'free' | 'pro';
  billingEnabled: boolean;
  grants?: readonly FeatureKey[];
  revocations?: readonly FeatureKey[];
}

export interface EntitlementDecision {
  allowed: boolean;
  reason: 'included' | 'granted' | 'revoked' | 'upgrade_required';
}

export function checkEntitlement(
  context: EntitlementContext,
  feature: FeatureKey,
): EntitlementDecision {
  if (context.revocations?.includes(feature)) return { allowed: false, reason: 'revoked' };
  if (context.grants?.includes(feature)) return { allowed: true, reason: 'granted' };
  if (planCanUse(context.plan, feature)) return { allowed: true, reason: 'included' };
  return { allowed: false, reason: 'upgrade_required' };
}

export function canUseFeature(context: EntitlementContext, feature: FeatureKey): boolean {
  return checkEntitlement(context, feature).allowed;
}
